import { toast } from 'sonner';

function useToast() {
    const error = (message: string) => {
        toast.error(message);
    };
    const info = (message: string) => {
        toast.info(message);
    };
    const success = (message: string) => {
        toast.success(message);
    };
    return {
        error, info, success,
    };
}

export default useToast;
